/**
 * Versión visible de la web (pie de página). Sirve para confirmar de un vistazo, desde el
 * teléfono de una clienta, qué build está sirviendo Hosting después de un deploy.
 *
 * Antes vivía como texto suelto dentro del formulario de registro (`v1.3.0`), donde no se
 * veía en las demás pantallas y era fácil olvidar actualizarla.
 */
export const APP_VERSION = '1.5.0';
